import * as React from "react";
import { Dropdown, Form, FormInput, Grid, GridColumn, GridRow, Input } from "@/components/bp/bp-ui";
import { IDropdownItem } from "./IDropdownItem";
import { TimeZonesClient, TimeZoneGroup } from "@app/api2/api";

interface IZone {
    country: string;
    zone: string;
}

interface ITimeZonePickerProps {
    name: string;
    value: string;
    country: string;
    onChange: (event: any, data: IZone) => void;
    readOnly?: boolean;
}

interface ICountryItem {
    key: string;
    value: string;
    flag: string;
    text: string;
}

class TimeZonePickerState {
    public loading: boolean = true;
    public search: string = "";
    public zoneList: Array<IDropdownItem<string>> = [];

    public country: string = "";
    public countryList: ICountryItem[] = [];

    public countryZones: TimeZoneGroup[] = [];
}

export class TimeZonePicker extends React.Component<ITimeZonePickerProps, TimeZonePickerState> {
    constructor(props, context) {
        super(props, context);
        this.state = new TimeZonePickerState();
    }

    public UNSAFE_componentWillReceiveProps(nextProps): void {
        const countryZones = this.state.countryZones.find((z) => z.countryCode === nextProps.country);
        let zones = null;
        if (countryZones) {
            zones = countryZones.timeZones.map((z) => ({
                key: z.zone,
                text: `(${z.offset}) ${z.zone}`,
                value: z.zone,
            }));
        }
        this.setState({
            country: nextProps.country,
            zoneList: zones,
        });
    }

    public async componentDidMount(): Promise<any> {
        const timeZoneClient = new TimeZonesClient();
        const timeZones = await timeZoneClient.get();

        const countryList = timeZones.map((c) => ({
            flag: c.countryCode,
            key: c.countryCode,
            text: c.country,
            value: c.countryCode,
        }));

        const countryZones = timeZones.find((z) => z.countryCode === this.props.country);

        let zones: Array<IDropdownItem<string>> = null;
        if (countryZones) {
            zones = countryZones.timeZones.map((z) => ({
                key: z.zone,
                text: `(${z.offset}) ${z.zone}`,
                value: z.zone,
            }));
        }
        this.setState({
            countryList,
            countryZones: timeZones,
            zoneList: zones,
        });
    }

    public render() {
        const country = this.state ? this.state.countryList.find(c => c.value == this.props.country) : null;
        return (
            <Grid columns={2}>
                <GridRow>
                    <GridColumn>
                        {!this.props.readOnly &&
                            <Dropdown fluid search selection options={this.state.countryList} value={this.props.country} placeholder="Country" onChange={this.countryChanged} />
                        }
                        {this.props.readOnly &&
                            <FormInput value={country ? country.text : ''} />
                        }
                    </GridColumn>
                    <GridColumn>
                        {!this.props.readOnly &&
                            <Dropdown fluid search selection options={this.state.zoneList} value={this.props.value} placeholder="Time Zone" onChange={this.zoneChanged} />
                        }
                        {this.props.readOnly &&
                            <FormInput value={this.props.value} />
                        }
                    </GridColumn>
                </GridRow>
            </Grid>
        );
    }

    private countryChanged = (e, data) => {
        this.props.onChange(e,
            {
                country: data.value,
                zone: null,
            });
    }

    private zoneChanged = (e, data) => {
        this.props.onChange(e,
            {
                country: this.state.country,
                zone: data.value,
            });
    }
}
